module.exports = __webpack_public_path__ + "img/電気回路_6_6.29ac4476.png";